import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralLighter,
    boxShadow: 'none',
    padding: pxToRem(24),
  },
  infoText: {
    paddingTop: pxToRem(8),
    fontWeight: 'normal',
  },
  contactInfo: {
    paddingTop: pxToRem(16),
    fontWeight: 'normal',
  },
  alignDiv: {
    paddingTop: pxToRem(3),
  },
  link: {
    textDecoration: 'none',
  },
  icon: {
    color: theme.palette.neutralTertiary,
    paddingRight: pxToRem(10),
  },
  titleText: {
    display: 'flex',
    paddingBottom: pxToRem(8),
  },
});
